import { useDispatch,useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { setAppError,setBreadCrumb } from "../../../../store/userSlice";
import { axios } from "../../../../Global";
import ArrivalList from "./ArrivalList";
import { Outlet, useLocation } from "react-router-dom";

const GlobalArrivalNotification = () =>{
    
  const token = localStorage.getItem("token");
  const [arrivalNotifications, setArrivalNotifications] = useState();
  const [filteredListData, setFilteredListData] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("Not Arrived");
  const [users, setUsers] = useState([]);
  const [dataLoading, setDataLoading] = useState(true);
  const [updateData, setUpdateData] = useState(false)
  const [allFiletypes,setAllFileTypes] = useState([])
  const [camps,setCamps] = useState([])
  const dispatch = useDispatch();
  const updatearrivalapi = useSelector((state) => state.updateArrival.active);
  const [showCandidate,setShowCandidate] = useState({open: false,candidate:[],})
  const location = useLocation();
  
  const isArrivalRoute = location.pathname.endsWith('/arrival-notification');
  const isCandidatesRoute = location.pathname.endsWith('/candidates')

  useEffect(()=>{
    if(isArrivalRoute){
      setShowCandidate({});
    }
    if(isCandidatesRoute)
      setShowCandidate({open: true});
  },[location]);

  const GetGlobalArrivalNotification = async () =>{
      setDataLoading(true);
      try {
          const result = await axios.get(`/dashboard/arrival-notification`,{
              headers:{ Authorization: `Bearer ${token}`}
          });
          
        const data = result?.data?.data?.arrival_notification;
          setArrivalNotifications(data);
          setAllFileTypes(result?.data?.data?.file_type);
          setCamps(result?.data?.data?.camp);
          const filteredData = data?.filter((item) => item?.status === selectedStatus)
          setFilteredListData(filteredData)
          setDataLoading(false);
      } catch (error) {
          setDataLoading(false);
          dispatch(setAppError({msg: error.message}));
      }
  }
  const getUsers = async () =>{
      setDataLoading(true);
      try {
          const result = await axios.get(`/dashboard/user`,{
              headers:{ Authorization: `Bearer ${token}`}
          });
          setDataLoading(false);
          setUsers(result?.data?.data);
      } catch (error) {
          setDataLoading(false);
          dispatch(setAppError({msg: error.message}));
      }
  }
  
  useEffect(() => {
    GetGlobalArrivalNotification();
    getUsers();
  }, [updateData, updatearrivalapi]);
  
  useEffect(() => {
      if (selectedStatus !== "") {
        const filteredData = arrivalNotifications?.filter(
          (item) => item?.status === selectedStatus
        );
        setFilteredListData(filteredData);
      } else {
          setFilteredListData(arrivalNotifications)
    }
  }, [selectedStatus, arrivalNotifications]);

  const commonItems = [{ label: "ARRIVAL NOTIFICATION", link: "" }];
  useEffect(() => {
    dispatch(setBreadCrumb(commonItems));
  }, []);
    
  return (
    <div className="p-4">
      {!showCandidate?.open && (
        <ArrivalList
          arrivalNotifications={arrivalNotifications}
          loading={dataLoading}
          candidateDetails={arrivalNotifications?.candidate}
          usersData={users}
          setUpdateData={setUpdateData}
          selectedStatus={selectedStatus}
          setSelectedStatus={setSelectedStatus}
          filteredListData={filteredListData}
          allFiletypes={allFiletypes}
          setShowCandidate={setShowCandidate}
        />
      )}
      {showCandidate?.open && (
        <Outlet
        context={[
                arrivalNotifications,
                allFiletypes,
                setUpdateData,
                setShowCandidate,
                camps,
            ]}
          />
        )}
    </div>
  );
}

export default GlobalArrivalNotification;